import React, { useEffect, useState } from "react";
import "../CSS/registerWarranty.css";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import Meta from "../Components/Meta";
import { getAllBikes } from "../Actions/bikeActions";
import { useDispatch, useSelector } from "react-redux";
import ReactPlayer from "react-player";
import Footer from "../Components/Footer";

const RegisterWarrantyScreen = () => {
  const dispatch = useDispatch();

  const [activeTab, setActiveTab] = useState(0);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [bike, setBike] = useState("");
  const [sourceOfPurchase, setsourceOfPurchase] = useState("");
  const [frameNumber, setFrameNumber] = useState("");
  const [dealerName, setDealerName] = useState("");
  const [errorFrameNo, setErrorFrameNo] = useState("");
  const [bikeName, setBikeName] = useState("");
  const [verified, setVerified] = useState(false);
  const [ageGroup, setAgeGroup] = useState("");
  const [usecase, setUsecase] = useState("");
  const [pincode, setPincode] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [manual, setManual] = useState(false);
  const [registered, setRegistered] = useState(false);
  const [loading, setLoading] = useState(false);
  const [pincodeId, setPincodeId] = useState("");
  const [stateId, setStateId] = useState("");
  const [districtId, setDistrictId] = useState("");
  const [franchiseId, setFranchiseId] = useState("");
  const [productId, setProductId] = useState("");
  const [dealerList, setDealerList] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredDealers, setFilteredDealers] = useState([]);
  const [bikeList, setBikeList] = useState([]);
  const [searchQueryBike, setSearchQueryBike] = useState("");
  const [filteredBikes, setFilteredBikes] = useState([]);
  const [selectedDealer, setSelectedDealer] = useState("");
  const [showSearchField, setShowSearchField] = useState(false);
  const [selectedBike, setSelectedBike] = useState("");
  const [productGroupId, setProductGroupId] = useState("");
  const [otp, setOtp] = useState("");
  const [otpVerified, setOtpVerified] = useState(false);
  const [otpSent, SetOtpSent] = useState(false);
  const [file, setFile] = useState();
  const [selectedAssemblyVideoBikeModel, setSelectedAssemblyVideoBikeModel] =
    useState("");
  const [selectedUserManualBikeModel, setSelectedUserManualBikeModel] =
    useState("");
  useEffect(() => {
    dispatch(getAllBikes());
  }, []);
  const allBikes = useSelector((state) => state.allBikes);
  const { bikes } = allBikes;
  const activeBikes = bikes?.filter(
    (bike) =>
      bike.active === true &&
      bike.name !== "G1 Cargo E-Cycle" &&
      bike.name !== "Lil E"
  );
  const tabs = [
    { name: "Warranty Registration", id: "warranty-registration-section" },
    { name: "Watch Assembly Video", id: "assembly-video-section" },
    { name: "Download User Manual", id: "user-manual-section" },
  ];

  const sendOtp = async () => {
    setOtp("");
    SetOtpSent(true);
    const { data } = await axios.post("/api/form/sms-otp", {
      phoneNumber,
    });
    if (data) {
      toast.success("OTP sent successfully", {
        autoClose: 2000,
        pauseOnHover: false,
      });
    }
  };

  const verifyOtp = async () => {
    if (otp.length === 4) {
      const { data } = await axios.patch("/api/form/sms-otp", {
        phoneNumber,
        otp: otp,
      });
      if (data) {
        setOtpVerified(true);
      }
    } else {
      alert("Please enter 4-digit OTP");
    }
  };

  const bikeData = [
    {
      name: "X1",
      image:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/know-your-ecycle/animation/X1+Blue.mp4",
      userManual:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/know-your-ecycle/usermanuals/X1.pdf",
      assemblyVideoURL: "https://youtu.be/CdOTzLPeVlc?si=3ieZZkQlfs_WabaU",
    },
    {
      name: "X2",
      image:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/know-your-ecycle/animation/X2.mp4",
      userManual:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/know-your-ecycle/usermanuals/X2.pdf",
      assemblyVideoURL: "https://youtu.be/Bfkmxy2dhlo?si=ch-JzfslmjC59XdV",
    },
    {
      name: "X3",
      image:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/know-your-ecycle/animation/X3.mp4",
      userManual:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/know-your-ecycle/usermanuals/X3.pdf",
      assemblyVideoURL: "https://youtu.be/hLbm8K9NF_0?si=IwnkiP4Q9SVxDFJp",
    },
    {
      name: "Neo",
      image:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/know-your-ecycle/animation/Neo.mp4",
      userManual:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/know-your-ecycle/usermanuals/X1+Neo.pdf",
      assemblyVideoURL: "https://youtu.be/CdOTzLPeVlc?si=3ieZZkQlfs_WabaU",
    },
    {
      name: "X1 Limited Edition",
      image:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/know-your-ecycle/animation/X1+LTD+edition.mp4",
      userManual:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/know-your-ecycle/usermanuals/X1.pdf",
      assemblyVideoURL: "https://youtu.be/CdOTzLPeVlc?si=3ieZZkQlfs_WabaU",
    },
    {
      name: "Legend 07 MSD Edition",
      image:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/know-your-ecycle/animation/legend+07.mp4",
      userManual:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/know-your-ecycle/usermanuals/X1-Dhoni+edition.pdf",
      assemblyVideoURL: "https://youtu.be/CdOTzLPeVlc?si=3ieZZkQlfs_WabaU",
    },
    {
      name: "EMX",
      image:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/know-your-ecycle/animation/EMX.mp4",
      userManual:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/know-your-ecycle/usermanuals/emx.pdf",
      assemblyVideoURL: "https://youtu.be/WpntY8JLCJo?si=wCyrFTsYAyeBF_6q",
    },
    {
      name: "EMX+",
      image:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/know-your-ecycle/animation/EMX%2B.mp4",
      userManual:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/know-your-ecycle/usermanuals/EMX%2B.pdf",
      assemblyVideoURL: "https://youtu.be/WpntY8JLCJo?si=wCyrFTsYAyeBF_6q",
    },
    {
      name: "Doodle V2",
      image:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/know-your-ecycle/animation/Doodle+V2.mp4",
      userManual:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/know-your-ecycle/usermanuals/doodle+V2.pdf",
      assemblyVideoURL: "https://youtu.be/GQLWFT-6ZWs?si=3jFHt0xisY5gR4qv",
    },
    {
      name: "Doodle V3",
      image:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/know-your-ecycle/animation/Doodle+v3.mp4",
      userManual:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing%20page/know-your-ecycle/usermanuals/Doodle%20V3.pdf",
      assemblyVideoURL: "https://youtu.be/GQLWFT-6ZWs?si=3jFHt0xisY5gR4qv",
    },
    {
      name: "Doodle Pro",
      image:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/know-your-ecycle/animation/Doodle+v3.mp4",
      userManual:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/know-your-ecycle/usermanuals/Doodle+Pro.pdf",
      assemblyVideoURL: "https://youtu.be/GQLWFT-6ZWs?si=3jFHt0xisY5gR4qv",
    },
    {
      name: 'T-Rex Air 27.5"',
      image:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/know-your-ecycle/animation/Trex+air.mp4",
      userManual:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/know-your-ecycle/usermanuals/T-Rex+Air+27.5.pdf",
      assemblyVideoURL: "https://youtu.be/qdkltRtWOWI?si=PBHOifp1A3f5_HSk",
    },
    {
      name: 'T-Rex Air 29"',
      image:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/know-your-ecycle/animation/Trex+air.mp4",
      userManual:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/know-your-ecycle/usermanuals/T-Rex+Air+29.pdf",
      assemblyVideoURL: "https://youtu.be/qdkltRtWOWI?si=PBHOifp1A3f5_HSk",
    },
    {
      name: "T-Rex+ V3",
      image:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/know-your-ecycle/animation/trex%2B+red+gif.mp4",
      userManual:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/know-your-ecycle/usermanuals/Trex%2B_User+Manual.pdf",
      assemblyVideoURL: "https://youtu.be/EwMO9cqNn1k?si=5eHrI3hNwSUEG5zt",
    },
    {
      name: "T-Rex Pro",
      image:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/know-your-ecycle/animation/trex%2B+red+gif.mp4",
      userManual:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/know-your-ecycle/usermanuals/Trex%2B_User+Manual.pdf",
      assemblyVideoURL: "https://youtu.be/c7fxxN3n7uU?si=yjN4ZNiixur9SDPx",
    },
    {
      name: "ST-X",
      image:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/know-your-ecycle/animation/STX+gif.mp4",
      userManual:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/know-your-ecycle/usermanuals/ST-X-USER_MANUAL.pdf",
      assemblyVideoURL: "https://youtu.be/CdOTzLPeVlc?si=GeXr_xUsEUJYHIGi",
    },
  ];
  const verifyFrameNo = async (e) => {
    const frameNumberPattern = /^[A-Z0-9]+$/; // Regex to match only uppercase letters and numbers

    if (!frameNumberPattern.test(frameNumber)) {
      toast.error(
        "Frame Number is invalid. Only uppercase letters and numbers are allowed.",
        {
          autoClose: 2000,
          pauseOnHover: false,
        }
      );
      setVerified(false);
      return;
    }

    try {
      const warrantyResponse = await axios.get(
        `/api/form/warranty/frame/${frameNumber}`
      );

      if (warrantyResponse.data && warrantyResponse.data.warranty) {
        toast.error("Frame Number Already Registered", {
          autoClose: 2000,
          pauseOnHover: false,
        });
        setRegistered(true);
        setVerified(false);
        return;
      }
      const response = await axios.get("/api/oms/frame", {
        params: {
          frame_number: frameNumber,
        },
      });
      setRegistered(false);
      setProductGroupId(response.data.data.product.product_group_id);
      setBikeName(response.data.data.product.product_name);
      setBike(response.data.data.product.product_name);
      if (response.data.data.customer.ecom_type) {
        setsourceOfPurchase(
          response.data.data.customer.ecom_type === "Website"
            ? "EM-Website"
            : response.data.data.customer.ecom_type
        );
        setDealerName("");
      } else {
        setDealerName(response.data.data.customer.customer_name);
        setsourceOfPurchase("Dealer");
      }
      setFranchiseId(response.data.data.customer.id);
      setProductId(response.data.data.frame.product_id);
      setVerified(true);
      setErrorFrameNo();
      toast.success("Frame Number Verified", {
        autoClose: 2000,
        pauseOnHover: false,
      });
    } catch (error) {
      if (
        error.response.status === 400 &&
        error.response.data.message === "Frame number already registered."
      ) {
        toast.error("Frame Number Already Registered", {
          autoClose: 2000,
          pauseOnHover: false,
        });
        setRegistered(true);
        setVerified(false);
        return;
      } else {
        alert("Frame Number not found, enter product details manually.");
        setBike("");
        setRegistered(false);
        setDealerName("");
        setVerified(true);
        setsourceOfPurchase("");
        setFranchiseId("");
        setBike("");
        setBikeName("");
        setProductId("");
        setFranchiseId("");
        setErrorFrameNo("error");
      }
    }
  };
  useEffect(() => {
    const fetchWarrantyDealers = async () => {
      try {
        const warrantyResponse = await axios.get(`/api/dealer/warranty`);
        if (warrantyResponse.status === 200) {
          setDealerList(warrantyResponse.data.dealers);
        }
      } catch (error) {
        console.error("Error fetching dealers:", error);
      }
    };

    const fetchWarrantyProducts = async () => {
      try {
        const warrantyResponse = await axios.get(`/api/products/warranty`);
        if (warrantyResponse.status === 200) {
          setBikeList(warrantyResponse.data.products);
        }
      } catch (error) {
        console.error("Error fetching dealers:", error);
      }
    };

    fetchWarrantyDealers();
    fetchWarrantyProducts();
  }, []);

  useEffect(() => {
    if (searchQuery && !selectedDealer) {
      const filtered = dealerList.filter((dealer) =>
        dealer.dealer_name.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setFilteredDealers(filtered);
    } else {
      setFilteredDealers([]);
    }
  }, [searchQuery, dealerList, selectedDealer]);

  useEffect(() => {
    if (searchQueryBike && !selectedBike) {
      const filtered = bikeList.filter((bike) =>
        bike.product_name.toLowerCase().includes(searchQueryBike.toLowerCase())
      );
      setFilteredBikes(filtered);
    } else {
      setFilteredBikes([]);
    }
  }, [searchQueryBike, bikeList, selectedBike]);

  // Handle selecting a dealer from the dropdown
  const handleSelectDealer = (dealerName, fr_id) => {
    setSelectedDealer(dealerName);
    setFranchiseId(fr_id);
    setSearchQuery(dealerName);
    setDealerName(dealerName);
    setFilteredDealers([]); // Hide the dropdown
  };

  const handleSelectBike = (productName, productId) => {
    setSelectedBike(productName);
    setProductId(productId);
    setSearchQueryBike(productName);
    setBike(productName);
    setFilteredBikes([]); // Hide the dropdown
  };

  useEffect(() => {
    if (pincode.length === 6) {
      axios
        .post(`api/oms/pincode`, { pincode })
        .then((response) => {
          setCity(response.data.data.district.district_name);
          setState(response.data.data.state.state_name);
          setPincodeId(response.data.data.pin.id);
          setDistrictId(response.data.data.district.id);
          setStateId(response.data.data.state.id);
        })
        .catch((error) => {
          toast.error("Pin code fetching error, try again!", {
            autoClose: 2000,
            pauseOnHover: false,
          });
        });
    }
  }, [pincode]);

  const resetFrameNo = async (e) => {
    setFrameNumber("");
    setVerified(false);
    setErrorFrameNo("");
    setDealerName("");
    setBike("");
    setBikeName("");
    setsourceOfPurchase("");
    setFranchiseId("");
    setProductId("");
    setFranchiseId("");
  };
  return (
    <>
      <Meta
        title={"Electric Bicycle Warranty | EMotorad Warranty"}
        description={
          "Ride with confidence - EMotorad's electric bicycle warranty covers you for the long haul. Discover how we safeguard your e-bike experience."
        }
        cannonicalTag={"https://www.emotorad.com/register-warranty"}
      />
      <ToastContainer />
      <div>
        <img
          src="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/warranty+banner.jpg"
          className="w-100"
        ></img>
      </div>
      {activeBikes && (
        <>
          {" "}
          <div className="px-lg-5 px-3">
            <div className="menu-tabs my-lg-5 my-4">
              {tabs.map((tab, index) => (
                <a
                  href={`#${tab.id}`}
                  key={index}
                  style={{ color: "inherit" }}
                  className={`text-decoration-none menu-tab metropolis-medium py-3 ${
                    activeTab === index ? "active" : ""
                  }`}
                  onClick={() => setActiveTab(index)}
                >
                  {tab.name}
                </a>
              ))}
            </div>
            <div
              id="warranty-registration-section"
              className="warranty-registration-section my-lg-5 p-4 p-lg-5"
            >
              <div className="py-3">
                <h5 className="metropolis-bold mb-lg-5 mb-4">
                  Warranty Registration Form
                </h5>
                <div className="row mb-2">
                  <div className="col-12 col-md-6">
                    <label className="form-label">Phone Number</label>
                    <div className="input-group mb-3">
                      <input
                        type="tel"
                        className="form-control"
                        placeholder="Enter phone number"
                        value={phoneNumber}
                        disabled={otpVerified}
                        required
                        onChange={(e) => {
                          setPhoneNumber(e.target.value.slice(0, 11));
                          e.target.setCustomValidity("");
                        }}
                        onInvalid={(e) =>
                          e.target.setCustomValidity(
                            "Enter a valid phone number"
                          )
                        }
                      />
                      {otpVerified ? (
                        <button
                          type="button"
                          className="btn fw-bold text-success btn-light verify-btn"
                        >
                          Verified
                        </button>
                      ) : otpSent ? (
                        <button
                          type="button"
                          onClick={sendOtp}
                          className="btn fw-bold btn-light verify-btn"
                        >
                          Resend OTP
                        </button>
                      ) : (
                        <button
                          type="button"
                          onClick={sendOtp}
                          className="btn fw-bold btn-light verify-btn"
                        >
                          Send OTP
                        </button>
                      )}
                    </div>
                  </div>
                  {!otpVerified && (
                    <div className="col-12 col-md-6">
                      <div className="mb-3">
                        <label className="form-label">OTP</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter OTP"
                          value={otp}
                          onChange={(e) => setOtp(e.target.value)}
                        />
                      </div>
                    </div>
                  )}
                </div>
                {!otpVerified ? (
                  <div className="d-flex otp-submit-btn">
                    <div className="mb-3">
                      <button
                        disabled={!phoneNumber && !otp}
                        onClick={verifyOtp}
                        className="btn btn-primary w-100"
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                ) : (
                  <div className="d-flex otp-submit-btn">
                    <div className="mb-3">
                      <button
                        onClick={() => {
                          setPhoneNumber("");
                          setOtpVerified(false);
                          setOtp("");
                          SetOtpSent(false);
                        }}
                        className="btn btn-secondary w-100"
                      >
                        Reset
                      </button>
                    </div>
                  </div>
                )}
              </div>
              <hr></hr>
              <div className="pt-4">
                <form>
                  <div className="row mb-lg-3">
                    <div className="col-12 col-md-6 mb-3">
                      <label className="form-label">Frame Number*</label>
                      <div className="input-group">
                        <input
                          type="tel"
                          className="form-control"
                          placeholder="Enter frame number"
                          value={frameNumber}
                          required
                          onChange={(e) => {
                            setFrameNumber(e.target.value);
                            e.target.setCustomValidity("");
                          }}
                          onInvalid={(e) =>
                            e.target.setCustomValidity(
                              "Enter a valid frame number(no lowercase characters, whitespaces or special characters)"
                            )
                          }
                        />
                        {!verified ? (
                          <button
                            type="button"
                            onClick={verifyFrameNo}
                            className="btn fw-bold btn-light verify-btn"
                          >
                            Verify
                          </button>
                        ) : (
                          <button
                            type="button"
                            onClick={resetFrameNo}
                            className="btn fw-bold btn-light verify-btn"
                          >
                            Reset
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row mb-lg-3">
                    <div className="col-12 col-md-6 mb-3">
                      <label className="form-label">Name*</label>
                      <div className="">
                        <input
                          type="tel"
                          className="form-control"
                          placeholder="Enter name"
                          value={name}
                          pattern="[A-Za-z\s]{2,}"
                          required
                          onChange={(e) => {
                            setName(e.target.value);
                            e.target.setCustomValidity("");
                          }}
                          onInvalid={(e) =>
                            e.target.setCustomValidity(
                              "Name should have at least 2 characters and contain only alphabets."
                            )
                          }
                        />
                      </div>
                    </div>
                    <div className="col-12 col-md-6 mb-3">
                      <div className="">
                        <label className="form-label">Email ID*</label>
                        <input
                          type="email"
                          className="form-control"
                          id="exampleFormControlInput1"
                          placeholder="Enter email"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row mb-lg-3">
                    <div className="col-12 col-md-6 mb-3">
                      <label className="form-label">Product Name*</label>
                      {!errorFrameNo ? (
                        <input
                          type="text"
                          disabled
                          required
                          name="bikeName"
                          className="form-control"
                          id="exampleFormControlInput1"
                          placeholder="Enter product name"
                          value={bikeName}
                          onChange={(e) => setEmail(e.target.value)}
                        />
                      ) : (
                        <div className="custom-select-wrapper">
                          <select
                            onChange={(e) => {
                              setBike(e.target.value);
                            }}
                            required
                            className="form-select custom-select-field"
                          >
                            <option value="" selected disabled>
                              Select product name
                            </option>
                            {bikeList.map((bike) => (
                              <option value={bike.product_name}>
                                {bike.product_name}
                              </option>
                            ))}
                          </select>
                        </div>
                      )}
                    </div>
                    <div className="col-12 col-md-6 mb-3">
                      <div className="">
                        <label className="form-label">
                          Source of Purchase*
                        </label>
                        <input
                          type="text"
                          required
                          className="form-control"
                          id="exampleFormControlInput1"
                          placeholder="Enter source of purchase"
                          value={sourceOfPurchase}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row mb-lg-3">
                    <div className="col-12 col-md-6 mb-3">
                      <label className="form-label">Pin Code*</label>
                      <div className="">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter pin code"
                          value={pincode}
                          required
                          name="pincode"
                          onChange={(e) => {
                            setPincode(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-12 col-md-6 mb-3">
                      <div className="">
                        <label className="form-label">State*</label>
                        <input
                          type="text"
                          className="form-control"
                          id="exampleFormControlInput1"
                          placeholder="Enter state"
                          value={state}
                          readOnly
                          onChange={(e) => setState(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row mb-lg-3">
                    <div className="col-12 col-md-6 mb-3">
                      <label className="form-label">City*</label>
                      <div className="">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter city"
                          readOnly
                          value={city}
                          required
                          name="pincode"
                          onChange={(e) => {
                            setCity(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-12 col-md-6 mb-3">
                      <label className="form-label">Date of Birth*</label>
                      <div className="custom-date-wrapper">
                        <input
                          type="date"
                          className="form-control custom-date-field"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row mb-lg-3">
                    <div className="col-12 col-md-6 mb-3">
                      <label className="form-label">Usecase*</label>
                      <div className="custom-select-wrapper">
                        <select
                          onChange={(e) => {
                            setUsecase(e.target.value);
                          }}
                          required
                          className="form-select custom-select-field"
                        >
                          <option value="" selected disabled>
                            Select use case
                          </option>
                          <option value="Health & Fitness">
                            Health & Fitness
                          </option>
                          <option value="Daily Use - Health">
                            Daily Use - Health
                          </option>
                          <option value="Daily Use - Cost Saving">
                            Daily Use - Cost Saving
                          </option>
                        </select>
                      </div>
                    </div>
                    <div className="col-12 col-md-6 mb-3">
                      <label className="form-label">Dealer Name*</label>
                      {!errorFrameNo ? (
                        <input
                          type="text"
                          readOnly
                          name="dealerName"
                          className="form-control"
                          id="exampleFormControlInput1"
                          placeholder="Enter dealer name"
                          value={dealerName}
                          onChange={(e) => setDealerName(e.target.value)}
                        />
                      ) : (
                        <div className="custom-select-wrapper">
                          <select
                            onChange={(e) => {
                              setDealerName(e.target.value);
                            }}
                            required
                            className="form-select custom-select-field"
                          >
                            <option value="" selected disabled>
                              Select dealer name
                            </option>
                            {dealerList.map((bike) => (
                              <option value={bike.product_name}>
                                {bike.product_name}
                              </option>
                            ))}
                          </select>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="my-4">
                    <label
                      htmlFor="file"
                      className="form-label text-center  w-100 rounded-3"
                      style={{
                        padding: "1.5em",
                        border: "1.5px dashed black",
                      }}
                    >
                      {file ? file.name : "UPLOAD INVOICE FILE*"}
                    </label>
                    <input
                      type="file"
                      hidden
                      name="file"
                      onChange={(e) => setFile(e.target.files[0])}
                      id="file"
                      placeholder=""
                    />
                  </div>
                  <div
                    className="d-flex justify-content-center"
                    style={{ gap: "1em" }}
                  >
                    <div>
                      <button className="btn btn-secondary px-5">Reset</button>
                    </div>
                    <div>
                      <button className="btn btn-primary px-5">Submit</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div
              id="assembly-video-section"
              className="assembly-video-section my-5"
            >
              <h5 className="metropolis-bold mb-4">Watch Assembly Video</h5>
              <div>
                <div className="mb-3">
                  <div className="custom-select-wrapper">
                    <select
                      onChange={(e) =>
                        setSelectedAssemblyVideoBikeModel(e.target.value)
                      }
                      className="form-select custom-select-field"
                    >
                      <option value="" selected disabled>
                        Select your bike model
                      </option>
                      {activeBikes.map((bike, index) => (
                        <option value={bike.name}>{bike.name}</option>
                      ))}
                    </select>
                  </div>
                </div>
                {selectedAssemblyVideoBikeModel && (
                  <div className="mb-3 w-100">
                    <ReactPlayer
                      url={
                        bikeData.find((bike) =>
                          bike.name.includes(selectedAssemblyVideoBikeModel)
                        )?.assemblyVideoURL
                      }
                      controls={true}
                      playing={false}
                      width={"100%"}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
          <div
            id="user-manual-section"
            className="user-manual-section mt-5 p-3 p-lg-5"
          >
            <div className="d-block d-md-flex">
              <div className="d-flex col-md-6 justify-content-center">
                <img
                  className="img-fluid"
                  src="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/usermanual.png"
                ></img>
              </div>
              <div className="col-md-6">
                <h5 className="metropolis-bold mb-4 text-center text-md-start">
                  Download User Manual
                </h5>
                <div>
                  <div className="mb-3 col-lg-8 col-12">
                    <div className="custom-select-wrapper">
                      <select
                        onChange={(e) =>
                          setSelectedUserManualBikeModel(e.target.value)
                        }
                        className="form-select custom-select-field w-100"
                      >
                        <option value="" selected disabled>
                          Select your bike model
                        </option>
                        <option value='T-Rex Air 27.5"'>T-Rex Air 27.5"</option>
                        <option value='T-Rex Air 29"'>T-Rex Air 29"</option>
                        {activeBikes
                          .filter((bike) => bike.name !== "T-Rex Air")
                          .map((bike, index) => (
                            <option value={bike.name}>{bike.name}</option>
                          ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-lg-3 col-12">
                    <a
                      href={
                        bikeData.find(
                          (bike) => bike.name === selectedUserManualBikeModel
                        )?.userManual
                      }
                      disabled={!selectedUserManualBikeModel}
                      className="btn btn-primary w-100"
                    >
                      Download
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className=" py-5 contact-us-section"
            style={{
              backgroundColor: "#f4f4f4",
            }}
          >
            <div className="container-md px-lg-5">
              <div
                className="d-flex service-blocks container-md px-lg-5"
                style={{ gap: "2em" }}
              >
                <div className="service-block w-100">
                  <a
                    href="tel:8956248161"
                    className="text-decoration-none"
                    style={{ color: "inherit" }}
                  >
                    <div
                      className="p-3 service-block-top"
                      style={{ backgroundColor: "white" }}
                    >
                      <p className="mb-0 service-block-text">
                        Facing a problem with your product or service? Our
                        dedicated service team is ready to assist you.
                      </p>
                    </div>
                    <div className="service-block-btn p-3">
                      <p className="mb-0">Call Us</p>
                    </div>
                  </a>
                </div>
                <div className="service-block w-100">
                  <a
                    href="mailto:service@emotorad.com"
                    className="text-decoration-none"
                    style={{ color: "inherit" }}
                  >
                    <div
                      className="p-3 service-block-top"
                      style={{ backgroundColor: "white" }}
                    >
                      <p className="mb-0 service-block-text">
                        For any unresolved concerns, feel free to drop us a
                        message.
                      </p>
                    </div>
                    <div className="service-block-btn p-3">
                      <p className="mb-0">E-mail us</p>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </>
      )}
    </>
  );
};

export default RegisterWarrantyScreen;
